import { KeyboardArrowUp } from "@mui/icons-material";
import { useScrollTop } from "itsf-ui-common";
import { KeyboardEvent } from "react";
import "./css/scrollTop.scss";

export const ScrollTopButton = () => {
    const { scrollTop, scrollPosition } = useScrollTop();

    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === "Enter") {
            scrollTop();
        }
    };

    return (
        <div
            className="scrollTop"
            role="button"
            style={{ display: `${scrollPosition > 200 ? "inline" : "none"}` }}
            tabIndex={0}
            onClick={scrollTop}
            onKeyDown={handleKeyDown}
        >
            <KeyboardArrowUp />
        </div>
    );
};
